var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cmpnts / KW43 / SVG / update_error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cmpnts-/-KW43-/-SVG-/-update_error",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99999996,34 L7.99999996,42 L40,42 L40,34 L44,34 L44,42 C44,44.206 42.206,46 40,46 L7.99999996,46 C5.79399996,46 3.99999996,44.206 3.99999996,42 L3.99999996,34 L7.99999996,34 Z M13.657,22 L22,30.343 L22,22.197 L22.0218974,22.2364553 C22.5859802,23.2086532 23.6036351,23.9175156 24.8596495,23.9932775 L25.0837296,24 L26,23.999 L26,30.343 L32.344,23.999 L38.001,23.999 L24,38 L7.99999997,22 L13.657,22 Z M26,1.99999995 L26,11.72 L22.0102403,18.7034788 L22,18.722 L22,1.99999995 L26,1.99999995 Z",
    id: "update_save",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4144166,2.77631017 C34.0058911,1.74122988 35.4976697,1.74122988 36.0891442,2.77631017 L36.0891442,2.77631017 L45.7568249,19.6957141 C46.3436784,20.7223227 45.6027951,22 44.4198462,22 L44.4198462,22 L25.0837146,22 C23.9015359,22 23.1598824,20.7223227 23.7467359,19.6957141 L23.7467359,19.6957141 Z M36.2518311,17 L33.2518311,17 L33.2518311,20 L36.2518311,20 L36.2518311,17 Z M36.2518311,5.99999995 L33.2518311,5.99999995 L34.0018311,15 L35.5018311,15 L36.2518311,5.99999995 Z",
    id: "update_error",
    fill: "#991717"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateError);
export default __webpack_public_path__ + "static/media/update_error.ddeb14964bf3a650b2610e8ecac530bc.svg";
export { ForwardRef as ReactComponent };